// extracted by mini-css-extract-plugin
export default {"wrapper":"Introduction_wrapper__fAALX","title":"Introduction_title__DpK7M","desc":"Introduction_desc__6sNFS"};